import { Empty, Select, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import LookupTable from "../../../../redux/models/lookupTable";

export const JobStatusSelector = ({ filterStatuses, ...props }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDropdownVisibleChange = async (open) => {
    if (open && !options.length) {
      try {
        setLoading(true);

        const data = await LookupTable.getJobStatuses(false);

        const filteredData = filterStatuses
          ? data.filter(({ name }) =>
              filterStatuses.some(
                (statusName) =>
                  name?.toLowerCase() === statusName?.toLowerCase(),
              ),
            )
          : data;

        setOptions(
          filteredData.map(({ id, name }) => ({ value: id, label: name })),
        );
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Select
      showSearch
      allowClear
      placeholder="Select Job Status"
      options={options}
      optionFilterProp="label"
      style={{ width: "100%" }}
      notFoundContent={
        loading ? (
          <Spin indicator={<LoadingOutlined spin />} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      onDropdownVisibleChange={handleDropdownVisibleChange}
      {...props}
    />
  );
};
